import { render } from "./HomePageNine.vue?vue&type=template&id=688a8f78&scoped=true"
import script from "./HomePageNine.vue?vue&type=script&lang=js"
export * from "./HomePageNine.vue?vue&type=script&lang=js"

import "./HomePageNine.vue?vue&type=style&index=0&id=688a8f78&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\TEMPLATES\\nuron-nft-marketplace-vue-js-template\\nuron-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688a8f78"]])

export default __exports__